import dayjs from "dayjs";

import { DAYS_OF_WEEK } from "@/common/constants/misc";

export const NOTIFICATION_FREQUENCY_IMMEDIATELY = "IMMEDIATELY";
export const NOTIFICATION_FREQUENCY_HOURLY = "HOURLY";
export const NOTIFICATION_FREQUENCY_DAILY = "DAILY";
export const NOTIFICATION_FREQUENCY_WEEKLY = "WEEKLY";

export const NOTIFICATION_FREQUENCY_OPTIONS = [
  {
    display: "Immediately",
    adverb: NOTIFICATION_FREQUENCY_IMMEDIATELY,
  },
  {
    display: "Hourly",
    adverb: NOTIFICATION_FREQUENCY_HOURLY,
  },
  {
    display: "Daily",
    adverb: NOTIFICATION_FREQUENCY_DAILY,
  },
  {
    display: "Weekly",
    adverb: NOTIFICATION_FREQUENCY_WEEKLY,
  },
];

export const NOTIFICATION_EXPIRATION_OPTIONS = [
  { id: 1, name: "1 week", value: 1, type: "weeks" },
  { id: 2, name: "2 weeks", value: 2, type: "weeks" },
  { id: 3, name: "3 weeks", value: 3, type: "weeks" },
  { id: 4, name: "Never", value: "never", type: null },
];

export const NOTIFICATION_COUNTRIES_LAYER_ID = "layer-country";
export const NOTIFICATION_COUNTRIES_LAYER_FIELD_ID = "_id";
export const NOTIFICATION_CITIES_LAYER_ID = "layer-city";
export const NOTIFICATION_CITIES_LAYER_FIELD_ID = "_id";

export const NOTIFICATION_TRIPWIRE_TYPES = [
  { text: "Risk Rating Changes Tripwire", value: "risk-rating" },
  { text: "Evacuation Changes Tripwire", value: "evacuation" },
  { text: "Hotspots Tripwire", value: "hotspot" },
  { text: "Pulse Score Changes Tripwire", value: "pulse" },
];
let docTypes = [{ text: "Saved Search", value: "saved-search" }];
docTypes = docTypes.concat(NOTIFICATION_TRIPWIRE_TYPES);
export const NOTIFICATION_DOC_TYPES = docTypes;

const daysOfWeek = DAYS_OF_WEEK.map((d) => d.name);

export const DEFAULT_NOTIFICATION = {
  formatted: {
    docType: "risk-rating",
    frequency: "IMMEDIATELY", // immediately, hourly, weekly, or daily
    dayOfWeek: daysOfWeek[dayjs().day()], // if weekly: monday, tuesday, wednesday, thursday, friday, saturday, sunday
    timeOfDay: `${dayjs().format("HH:mm")}`, // if weekly or daily: has to be on the hour or half hour only, use 24hr clock
    expiration: 1, // never, 1 week, 2 weeks, 3 weeks (set the date in the future)
    expirationDate: dayjs().add(1, "week").toISOString(),
    delivery: ["email"], // email, push, target
    targets: [],
    sharedList: [], // array of objects containing userid and email
    params: {},
  },
};
